import * as actionTypes from "./actionTypes";
import * as types from "./types";


// GET Target

const initTargetListState: types.TargetListState = {
    pending: false,
    targets: {} as types.IDataTargetList,
    error: null,
};

export const TargetListReducer = (state = initTargetListState, action: types.TargetListActions) => {
    switch (action.type) {
        case actionTypes.FETCH_TARGET_LIST_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_TARGET_LIST_SUCCESS:
            return {
                ...state,
                pending: false,
                targets: action.payload.targets,
                error: null,
            };
        case actionTypes.FETCH_TARGET_LIST_FAILURE:
            return {
                ...state,
                pending: false,
                targets: {} as types.IDataTargetList,
                error: action.payload.error,
            };
            
        default:
            return {
                ...state,
            };
    }
};


// GET Target Details

const initTargetState: types.ITargetState = {
    pending: false,
    target: null,
    error: null,
};

export const TargetDetailsReducer = (state = initTargetState, action: types.TargetActions) => {
    switch (action.type) {
        case actionTypes.FETCH_TARGET_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_TARGET_SUCCESS:
            return {
                ...state,
                pending: false,
                target: action.payload.target,
                error: null,
            };
        case actionTypes.FETCH_TARGET_FAILURE:
            return {
                ...state,
                pending: false,
                target: null,
                error: action.payload.error,
            };
            case actionTypes.FETCH_TARGET_RESET:
                return {
                    ...state,
                    pending: false,
                    target: null,
                    error: null,
                };
        default:
            return {
                ...state,
            };
    }
};


// POST Data Target

const initialStateDataTarget: types.IPostDataTargetState = {
    pending: false,
    dataTarget: null,
    error: null,
};

export const PostDataTargetReducer = (state = initialStateDataTarget, action: types.PostDataTargetActions) => {

    switch (action.type) {
        case actionTypes.POST_DATATARGET_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.POST_DATATARGET_SUCCESS:
            return {
                ...state,
                pending: false,
                dataTarget: action.payload.dataTarget,
                error: null,
            };
        case actionTypes.POST_DATATARGET_FAILURE:
            return {
                ...state,
                pending: false,
                dataTarget: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }

};




// PUT DATA TARGET

const initialStatePutDataTarget: types.IPutDataTargetState = {
    pending: false,
    dataTarget: null,
    error: null,
};

export const PutDataTargetReducer = (state = initialStatePutDataTarget, action: types.PutDataTargetActions) => {
        switch (action.type) {

        case actionTypes.PUT_DATATARGET_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.PUT_DATATARGET_SUCCESS:
            return {
                ...state,
                pending: false,
                dataTarget: action.payload.dataTarget,
                error: null,
            };
        case actionTypes.PUT_DATATARGET_FAILURE:
            return {
                ...state,
                pending: false,
                dataTarget: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }

};


// DELETE Target Details

const initDeleteTargetState: types.IDeleteDataTargetState = {
    pending: false,
    success: null,
    error: null,
};

export const DeleteTargetReducer = (state = initDeleteTargetState, action: types.DeleteDataTargetActions) => {
    switch (action.type) {
        case actionTypes.DELETE_TARGET_REQUEST:
            return {
                ...state,
                success: null,
                pending: true,
            };
        case actionTypes.DELETE_TARGET_SUCCESS:
            return {
                ...state,
                pending: false,
                success: action.success,
                error: null,
            };
        case actionTypes.DELETE_TARGET_FAILURE:
            return {
                ...state,
                pending: false,
                success: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

export default { TargetListReducer };


